// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogReportPaid__Component__Loading[data-v-160bf2be] {\n  max-height: 600px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
